import { ThemeEvents } from '@theme/events';

/**
 * Keeps ERP article fragments in sync with Horizon's section-rendered variant
 * response. Invalid or missing contracts are rendered by Liquid as complete
 * native parent fallbacks before the fragment is replaced.
 */
class ArticlePresentationFragment extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    if (this.#controller.signal.aborted) {
      this.#controller = new AbortController();
    }

    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * @param {CustomEvent} event
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.productId !== this.dataset.productId) return;

    const source = event.detail.data.html;
    if (!source) return;

    const matchingFragment = Array.from(source.querySelectorAll(this.localName)).find(
      (element) =>
        element instanceof HTMLElement &&
        element.dataset.productId === this.dataset.productId &&
        element.dataset.blockId === this.dataset.blockId
    );

    if (!matchingFragment) return;
    this.replaceWith(matchingFragment);
  };
}

class ArticlePresentationTitle extends ArticlePresentationFragment {}
class ArticlePresentationContent extends ArticlePresentationFragment {}

if (!customElements.get('article-presentation-title')) {
  customElements.define('article-presentation-title', ArticlePresentationTitle);
}

if (!customElements.get('article-presentation-content')) {
  customElements.define('article-presentation-content', ArticlePresentationContent);
}
